import { useState } from "react";

/**
 * Hook to manage and track the submitting state of a form,
 * ensuring loading indicators are accurate and preventing duplicate submissions.
 */
export const useFormSubmittingState = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const withSubmitting = async <T>(fn: (() => Promise<T>) | undefined) => {
    if (!fn) {
      return;
    }

    setIsSubmitting(true);
    await fn();
    setTimeout(() => {
      setIsSubmitting(false);
    }, 1000);
  };

  return { isSubmitting, setIsSubmitting, withSubmitting };
};
